export const contactDefaultState =   [
    {
        name: 'Contact ID',
        checked: true,
        property_name: 'id',
    },
    {
        name: 'Contact',
        checked: true,
        property_name: 'name',
    },
    {
        name: 'Email',
        checked: true,
        property_name: 'email',
    },
    {
        name: 'Cell',
        checked: true,
        property_name: 'cell',
    },
    {
        name: 'Title',
        checked: true,
        property_name: 'title',
    },
    {
        name: 'Followup',
        checked: true,
        property_name: 'date',
    },
    {
        name: 'User',
        checked: true,
        property_name: 'user',
    },
    {
        name: 'Company Name',
        checked: true,
        property_name: 'company_name',
    },
    {
        name: 'Contact Type',
        checked: true,
        property_name: 'contact_type',
    },
    {
        name: 'Contact Status',
        checked: true,
        property_name: 'contact_status',
    },
    {
        name: 'Created Date',
        checked: true,
        property_name: 'created_date',
    },
    {
        name: 'Last Update',
        checked: true,
        property_name: 'last_update',
    }
]
export const projectColumnListForCustomProjectSetting = [
    { 'name': 'Project Custom ID', 'property_name': 'sequential_team_id', 'is_custom_field': false, 'custom_field_id': null, 'is_record_detail_custom_field': false, 'record_detail_custom_field_id': null, 'custom_field_type': null, 'custom_field_options': [], 'is_sales_behavior': false, 'sales_behavior_id': null },
    { 'name': 'Project Name', 'property_name': 'name', 'is_custom_field': false, 'custom_field_id': null, 'is_record_detail_custom_field': false, 'record_detail_custom_field_id': null, 'custom_field_type': null, 'custom_field_options': [], 'is_sales_behavior': false, 'sales_behavior_id': null },
    { 'name': 'Project Contact', 'property_name': 'contact_name', 'is_custom_field': false, 'custom_field_id': null, 'is_record_detail_custom_field': false, 'record_detail_custom_field_id': null, 'custom_field_type': null, 'custom_field_options': [], 'is_sales_behavior': false, 'sales_behavior_id': null },
    { 'name': 'Status', 'property_name': 'sales_statuses_code', 'is_custom_field': false, 'custom_field_id': null, 'is_record_detail_custom_field': false, 'record_detail_custom_field_id': null, 'custom_field_type': null, 'custom_field_options': [], 'is_sales_behavior': false, 'sales_behavior_id': null },
    { 'name': 'Base Bid', 'property_name': 'base_bid', 'is_custom_field': false, 'custom_field_id': null, 'is_record_detail_custom_field': false, 'record_detail_custom_field_id': null, 'custom_field_type': null, 'custom_field_options': [], 'is_sales_behavior': false, 'sales_behavior_id': null },
    { 'name': 'Address', 'property_name': 'address', 'is_custom_field': false, 'custom_field_id': null, 'is_record_detail_custom_field': false, 'record_detail_custom_field_id': null, 'custom_field_type': null, 'custom_field_options': [], 'is_sales_behavior': false, 'sales_behavior_id': null }
]

export const projectContactField =  [
    {
        value: "project_contact_name",
        label: "Project Contact Name",
        disabled: false,
        object_type: "Project",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        is_project_contact:true,
        options: null
    },
    {
        value: "phone",
        label: "Phone",
        disabled: false,
        object_type: "Project",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        is_project_contact:true,
        options: null
    },
    {
        value: "fax",
        label: "Fax",
        disabled: false,
        object_type: "Project",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        is_project_contact:true,
        options: null
    },
    {
        value: "cell",
        label: "Cell",
        disabled: false,
        object_type: "Project",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        is_project_contact:true,
        options: null
    },
    {
        value: "email",
        label: "Email",
        disabled: false,
        object_type: "Project",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        is_project_contact:true,
        options: null
    },
]

export const erpProjectFields = [
    {
        value: "id",
        label: "Project Seq ID/Custom #",
        disabled: false,
        object_type: "Project",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "job_number",
        label: "Auto-generated Job # based on vista Job# (N/A to alphanumeric)",
        disabled: false,
        object_type: "Project",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "name",
        label: "Name",
        disabled: false,
        object_type: "Project",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "address",
        label: "Address",
        disabled: false,
        object_type: "Project",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "city",
        label: "City",
        disabled: false,
        object_type: "Project",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "state",
        label: "State",
        disabled: false,
        object_type: "Project",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "zip",
        label: "Zip Code",
        disabled: false,
        object_type: "Project",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "base_bid",
        label: "Base Bid",
        disabled: false,
        object_type: "Project",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "contract_amount",
        label: "Contract Amount",
        disabled: false,
        object_type: "Project",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "contract_date",
        label: "Contract Date",
        disabled: false,
        object_type: "Project",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "bid_date",
        label: "Bid Date",
        disabled: false,
        object_type: "Project",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "pre_bid",
        label: "Pre bid",
        disabled: false,
        object_type: "Project",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "sales_status_id",
        label: "Sales Status",
        disabled: false,
        object_type: "Project",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: true,
        options: null
    },
    {
        value: "marketing_status_id",
        label: "Marketing Status",
        disabled: false,
        object_type: "Project",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: true,
        options: null
    },
    {
        value: "lead_from_id",
        label: "Lead Source",
        disabled: false,
        object_type: "Project",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: true,
        options: null
    },
    {
        value: "account_manager_id",
        label: "Account Manager",
        disabled: false,
        object_type: "Project",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: true,
        options: null
    },
    {
        value: "estimator_id",
        label: "Estimator",
        disabled: false,
        object_type: "Project",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: true,
        options: null
    },
    {
        value: "take_off_person_id",
        label: "Take Off Person",
        disabled: false,
        object_type: "Project",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: true,
        options: null
    },
    {
        value: "products_and_services_id",
        label: "Products & Services",
        disabled: false,
        object_type: "Project",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: true,
        options: null
    },
    {
        value: "client_profile_id",
        label: "Client Profile",
        disabled: false,
        object_type: "Project",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: true,
        options: null
    },
    {
        value: "contract_type_id",
        label: "Contract Type",
        disabled: false,
        object_type: "Project",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: true,
        options: null
    },
    {
        value: "estimated_contract_date",
        label: "Estimated Contract Date",
        disabled: false,
        object_type: "Project",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "gross_margin_percentage",
        label: "Gross Margin %",
        disabled: false,
        object_type: "Project",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "labor_hours",
        label: "Labor Hours",
        disabled: false,
        object_type: "Project",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },{
        value: "office_id",
        label: "Office/Location",
        disabled: false,
        object_type: "Project",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: true,
        options: null
    },
    {
        value: "project_comment",
        label: "Project Comment",
        disabled: false,
        object_type: "Project",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        is_project_comment:true,
        options: null
    }
];
export const erpContactFields = [
    {
        value: "id",
        label: "ID",
        disabled: false,
        object_type: "CompanyContact",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "name",
        label: "Name",
        disabled: false,
        object_type: "CompanyContact",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "email",
        label: "Email",
        disabled: false,
        object_type: "CompanyContact",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "cell",
        label: "Cell",
        disabled: false,
        object_type: "CompanyContact",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "title",
        label: "Title",
        disabled: false,
        object_type: "CompanyContact",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "contact_types_id",
        label: "Contact Type",
        disabled: false,
        object_type: "CompanyContact",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: true,
        options: null
    },
    {
        value: "team_contact_status",
        label: "Status",
        disabled: false,
        object_type: "CompanyContact",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: true,
        options: null
    },
    {
        value: "user_id",
        label: "User",
        disabled: false,
        object_type: "CompanyContact",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: true,
        options: null
    }
];

export const erpResidentialContactFields = [
    {
        value: "address",
        label: "Address",
        disabled: false,
        object_type: "CompanyContact",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "city",
        label: "City",
        disabled: false,
        object_type: "CompanyContact",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "state",
        label: "State",
        disabled: false,
        object_type: "CompanyContact",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "zip",
        label: "Zip Code",
        disabled: false,
        object_type: "CompanyContact",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    // {
    //     value: "team_contact_status",
    //     label: "Status",
    //     disabled: false,
    //     object_type: "CompanyContact",
    //     is_custom_field: false,
    //     is_dropdown_field: true,
    //     options: null
    // },
    // {
    //     value: "user_id",
    //     label: "User",
    //     disabled: false,
    //     object_type: "CompanyContact",
    //     is_custom_field: false,
    //     is_dropdown_field: true,
    //     options: null
    // }
];
export const erpFoundationExtendFields = [
    {
        value: "customer_number",
        label: "Auto-generated Customer # (N/A to alphanumeric)",
        disabled: false,
        object_type: "Company",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
]
export const erpFoundationExtendFieldsForContact = [
    {
        value: "customer_number",
        label: "Auto-generated Customer # (N/A to alphanumeric)",
        disabled: false,
        object_type: "CompanyContact",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
]

export const erpCompanyFields = [
    {
        value: "id",
        label: "ID",
        disabled: false,
        object_type: "Company",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "name",
        label: "Name",
        disabled: false,
        object_type: "Company",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "address",
        label: "Address",
        disabled: false,
        object_type: "Company",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "city",
        label: "City",
        disabled: false,
        object_type: "Company",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "state",
        label: "State",
        disabled: false,
        object_type: "Company",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "zip",
        label: "Zip Code",
        disabled: false,
        object_type: "Company",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "phone",
        label: "Phone",
        disabled: false,
        object_type: "Company",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "fax",
        label: "Fax",
        disabled: false,
        object_type: "Company",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "site",
        label: "Web Site",
        disabled: false,
        object_type: "Company",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "company_types_id",
        label: "Company Type",
        disabled: false,
        object_type: "Company",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: true,
        options: null
    },
    {
        value: "team_company_status",
        label: "Status",
        disabled: false,
        object_type: "Company",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: true,
        options: null
    },
];

export const erpProjectChangeOrderFields = [
    {
        value: "name",
        label: "Change Order Name",
        disabled: false,
        object_type: "ProjectChangeOrder",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "sales_status_id",
        label: "Sales Status",
        disabled: false,
        object_type: "ProjectChangeOrder",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: true,
        options: null
    },
    {
        value: "base_bid",
        label: "Base Bid",
        disabled: false,
        object_type: "ProjectChangeOrder",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "contract_amount",
        label: "Contract Amount",
        disabled: false,
        object_type: "ProjectChangeOrder",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "contract_date",
        label: "Contract Date",
        disabled: false,
        object_type: "ProjectChangeOrder",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "bid_date",
        label: "Bid Date",
        disabled: false,
        object_type: "ProjectChangeOrder",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    },
    {
        value: "gross_margin_percentage",
        label: "Gross Margin%",
        disabled: false,
        object_type: "ProjectChangeOrder",
        is_custom_field: false,
        is_record_detail_custom_field: false,
        is_dropdown_field: false,
        options: null
    }

];
export const erpObjectOptions = {
    follow_up: [
        {
            custom_id: 1,
            value: "Project",
            label: "Project",
            disabled: false
        },
        {
            custom_id: 2,
            value: "Company",
            label: "Company",
            disabled: false
        },
        {
            custom_id: 3,
            value: "Residential-contact",
            label: "Residential Contact",
            disabled: false
        },
        {
            custom_id: 4,
            value: "Project-change-order",
            label: "Project | Change Orders",
            disabled: false
        }
    ],
    follow_up_change_order: [
        {
            custom_id: 4,
            value: "Project-change-order",
            label: "Project | Change Orders",
            disabled: false
        }
    ],
    vista: [
        {
            custom_id: 1,
            value: "JCJM",
            label: "JC Jobs",
            disabled: false
        },
        {
            custom_id: 2,
            value: "ARCM",
            label: "AR Customers",
            disabled: false
        },
        {
            custom_id: 4,
            value: "ACO",
            label: "Change Order",
            disabled: false
        },
        {
            custom_id: 5,
            value: "vSMWorkOrder",
            label: "SM Work Order",
            disabled: false
        },
        {
            custom_id: 6,
            value: "vSMServiceSite",
            label: "SM Service Site",
            disabled: false
        },
        {
            custom_id: 7,
            value: "bJCCM",
            label: "JC Contracts",
            disabled: false
        }
    ],
    spectrum: [
        {
            custom_id: 1,
            value: "JC_JOB_MASTER_MC",
            label: "Jobs",
            disabled: false
        },
        {
            custom_id: 2,
            value: "CR_CUSTOMER_MASTER_MC",
            label: "Customers",
            disabled: false
        },
        {
            custom_id: 4,
            value: "CR_CHNG_REQ_HDR_MC",
            label: "Change Request",
            disabled: false
        }
    ],
    foundationNew:[
        {
            custom_id: 1,
            value: "jobs",
            label: "Jobs",
            disabled: false
        },
        {
            custom_id: 2,
            value: "customers",
            label: "Customers",
            disabled: false
        },
        {
            custom_id: 3,
            value: "job_chg",
            label: "Change Order",
            disabled: false
        },
    ],
    computerEase: [
        {
            custom_id: 1,
            value: "CE_jobs",
            label: "Jobs",
            disabled: false
        },
        // {
        //     custom_id: 2,
        //     value: "customer",
        //     label: "Customers",
        //     disabled: true
        // }
    ],
    sage100: [
        {
            value:'actrec',
            label:'Jobs (Accounts Receivable)',
            disabled: false
        },
        {
            value:'reccln',
            label:'Receivable Clients (for Company)',
            disabled: false
        },
        {
            value:'clncnt',
            label:'Receivable Clients (for Residential Contact)',
            disabled: false
        },
        {
            value:'CHANGE_ORDER',
            label:'Change Order',
            disabled: false
        }
    ],
    sage300: [
        {
            value:'MASTER_JCM_RECORD_1',
            label:'Job Cost',
            disabled: false
        },
        {
            value:'MASTER_ARM_RECORD_1',
            label:'Accounts Receivable (for Company)',
            disabled: false
        },
        {
            value:'STANDARD_ARS_RECORD_1',
            label:'Accounts Receivable (for Residential Contact)',
            disabled: false
        },
        {
            value:'CHANGE_ORDER',
            label:'Change Order',
            disabled: false
        }
    ]
};

export const erpAgaveFields = {
    JCJM: [
        {
            value: "number",
            label: "Job",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: true
        },
        {
            value: "name",
            label: "Description",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: true
        },
        {
            value: "street_1",
            label: "MailAddress",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: true
        },
        {
            value: "city",
            label: "MailCity",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: true
        },
        {
            value: "state",
            label: "MailState",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: true
        },
        {
            value: "postal_code",
            label: "MailZip",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: true
        },
        {
            value: "start_date",
            label: "StartDate",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: true
        },
        {
            value: "description",
            label: "Notes",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "ProjectMgr",
            label: "ProjectMgr",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        }
    ],
    ARCM: [
        {
            value: "name",
            label: "Name",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: true
        },
        {
            value: "phone",
            label: "Phone",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "email",
            label: "EMail",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "street_1",
            label: "Address",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "city",
            label: "City",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "state",
            label: "State",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "postal_code",
            label: "Zip",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "Contact",
            label: "Contact",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "terms",
            label: "PayTermsDescription",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "BillAddress",
            label: "BillAddress",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "BillCity",
            label: "BillCity",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "BillState",
            label: "BillState",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "BillZip",
            label: "BillZip",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "udCompanyType",
            label: "udCompanyType",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        }
    ],
    ACO: [
        {
            value: "description",
            label: "Description",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "revenue",
            label: "Revenue",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "approval_date",
            label: "Approval Date",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "gross_margin_percentage",
            label: "Gross Margin%",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        }
    ],
    JC_JOB_MASTER_MC: [
        {
            value: "number",
            label: "Job_Number",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: true
        },
        {
            value:'name',
            label:'Job_Description',
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value:'street_1',
            label:'Address_1',
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value:'street_2',
            label:'Address_2',
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value:'city',
            label:'City',
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value:'state',
            label:'State',
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value:'postal_code',
            label:'Zip_Code',
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value:'start_date',
            label:'Start_Date',
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value:'completion_date',
            label:'Complete_Date',
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value:'status',
            label:'Status_Code',
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        },
        {
            value: "Estimator",
            label: "Estimator",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        },
        {
            value: "Superintendent",
            label: "Superintendent",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        },
        {
            value: "Comment",
            label: "Comment",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "Project_Manager",
            label: "Project_Manager",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        },
        {
            value: "amount",
            label: "Original_Contract",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "Labor_Hours",
            label: "Labor Hours",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "Labor_Costs",
            label: "Labor Costs",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "Materials_Costs",
            label: "Materials Costs",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "Other_Costs",
            label: "Equipment/Other Costs",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "Subcontractors",
            label: "Subcontractors",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "Burden_Costs",
            label: "Burden Costs",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "Permits_Costs",
            label: "Permits Costs",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "Temporary_Labor_Costs",
            label: "Temporary Labor Costs",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        }
    ],
    CR_CUSTOMER_MASTER_MC: [
        {
            value: "Customer_Code",
            label: "Customer_Code",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: true
        },
        {
            value: "name",
            label: "Name",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: true
        },
        {
            value: "email",
            label: "Customer_Email",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "phone",
            label: "Phone",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "street_1",
            label: "Address_1",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "street_2",
            label: "Address_2",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "city",
            label: "City",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "state",
            label: "State",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "postal_code",
            label: "Zip_Code",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value:'Status',
            label:'Status',
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        },
        {
            value:'Salesperson',
            label:'Salesperson',
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        },
        {
            value:'Type',
            label:'Type',
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
    ],
    CR_CHNG_REQ_HDR_MC: [
        {
            value: "Description",
            label: "Description",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: true
        },
        {
            value: "Change_Order_Number",
            label: "Change Order",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "Status_Description",
            label: "Current Status",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: true
        },
        {
            value: "Origination_Date",
            label: "Origination Date",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "Approved_Date",
            label: "Approved Date",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "Total_Cost",
            label: "Take off Total",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        // {
        //     value: "job_total",
        //     label: "Job Total",
        //     disabled: false,
        //     is_dropdown_field: false,
        //     options: null,
        //     required: false
        // },
        {
            value: "Submitted_Amount",
            label: "Change Request Total",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        // {
        //     value: "gross_margin_percentage",
        //     label: "Gross Margin%",
        //     disabled: false,
        //     is_dropdown_field: false,
        //     options: null,
        //     required: false
        // },
        {
            value: "Labor_Hours",
            label: "Labor Hours",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "Labor_Costs",
            label: "Labor Costs",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "Materials_Costs",
            label: "Materials Costs",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "Other_Costs",
            label: "Equipment/Other Costs",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "Subcontractors",
            label: "Subcontractors",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "billing_amount",
            label: "Billing Amount",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "Billing_Adjustment",
            label: "Billing Adjustment",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "Burden_Costs",
            label: "Burden Costs",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "Permits_Costs",
            label: "Permits Costs",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "Temporary_Labor_Costs",
            label: "Temporary Labor Costs",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        }
    ],
    vSMWorkOrder: [
        {
            value: "contact_name",
            label: "ContactName",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "contact_phone",
            label: "ContactPhone",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "description",
            label: "Description",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "technician_employee_id",
            label: "LeadTechnician",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        },
        {
            value: "order_date",
            label: "EnteredDateTime",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "request_date",
            label: "RequestedDate",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "request_time_of_day",
            label: "RequestedTime",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "ServiceCenter",
            label: "ServiceCenter",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        },
        {
            value: "PRLocalCode",
            label: "PRLocalCode",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        },
        {
            value: "PRState",
            label: "PRState",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        },
        {
            value: "Reviewer",
            label: "Reviewer",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        },
        {
            value: "ServiceSite",
            label: "ServiceSite",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        },
        {
            value: "udMarketSector",
            label: "udMarketSector",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        },
        {
            value: "udBidNumber",
            label: "udBidNumber",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        }
    ],
    vSMServiceSite: [
        {
            value: "SMCo",
            label: "SMCo",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "ServiceSite",
            label: "ServiceSite",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "Customer",
            label: "Customer",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "Description",
            label: "Description",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "Address1",
            label: "Address1",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "Address2",
            label: "Address2",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "City",
            label: "City",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "State",
            label: "State",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "Zip",
            label: "Zip",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "Country",
            label: "Country",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "Phone",
            label: "Phone",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "TaxCode",
            label: "TaxCode",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        },
        {
            value: "UseTaxCode",
            label: "UseTaxCode",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        },
        {
            value: "Reviewer",
            label: "Reviewer",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        },
        {
            value: "CustomerPOSetting",
            label: "CustomerPOSetting",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        },
        {
            value: "PRLocalCode",
            label: "PRLocalCode",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        },
        {
            value: "InsCode",
            label: "InsCode",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        },
        {
            value: "CraftTemplate",
            label: "CraftTemplate",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        },
        {
            value: "udSvcLocType",
            label: "udSvcLocType",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        }
    ],
    jobs: [
        {
            value: "number",
            label: "job_no",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: true
        },
        {
            value: "name",
            label: "description",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: true
        },
        {
            value: "description",
            label: "comments",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "completion_date",
            label: "completion_date",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "amount",
            label: "original_contract",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "street_1",
            label: "address_1",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "street_1",
            label: "address_2",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "city",
            label: "city",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "state",
            label: "state",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "postal_code",
            label: "zip_code",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "start_date",
            label: "job_start_date",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "completion_date",
            label: "completion_date",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "type",
            label: "project_class_no",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        },
        {
            value: "project_manager_no",
            label: "project_manager_no",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        },
        {
            value: "geo_area_no",
            label: "geo_area_no",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        },
        {
            value: "estimator_no",
            label: "estimator_no",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        },
        {
            value: "customer_order_no",
            label: "customer_order_no",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        },
        {
            value: "dept_no",
            label: "dept_no",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        },
        {
            value: "tax_ap_no",
            label: "tax_ap_no",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        },
        {
            value: "division_1",
            label: "division_1",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        },
        {
            value: "division_2",
            label: "division_2",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        },
        {
            value: "original_cost",
            label: "original_cost",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "customer_contact",
            label: "customer_contact",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        }
    ],
    customers:[
        {
            value: "name",
            label: "name",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: true
        },
        {
            value: "code",
            label: "customer_no",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: true
        },
        {
            value: "street_1",
            label: "address_1",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "city",
            label: "city",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "state",
            label: "state",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "postal_code",
            label: "zip_code",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "phone",
            label: "phone_voice",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "contact",
            label: "contact",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "phone_fax",
            label: "phone_fax",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "email",
            label: "email_address",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        }, {
            value: "phone_data",
            label: "phone_data",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },

        ],
    job_chg:[
/*        {
            value: "change_order_no",
            label: "change_order_no",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "revenue_amount",
            label: "tot_income_adj",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "cost_amount",
            label: "tot_cost_adj",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "issue_date",
            label: "date_booked",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        }*/
        {
            value: "status",
            label: "status",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false
        }
    ],
    CE_jobs: [
        {
            value: "code",
            label: "Job",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "description",
            label: "Job Name",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "address",
            label: "Address",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "city",
            label: "City",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "state",
            label: "State",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "zipcode",
            label: "Zip",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "status",
            label: "Status",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "customer_name",
            label: "Customer",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "job_ponum",
            label: "PO Number",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "job_class",
            label: "Class",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "job_dept",
            label: "Department",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "jobdate_open",
            label: "Date Open",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "jobdate_due",
            label: "Date Due",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "salestax_code",
            label: "Sales Tax Code",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "posalestax_code",
            label: "PO Sales Tax Code",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "tmbilling_code",
            label: "T&M Billing Code",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "billing_notes",
            label: "Billing Notes",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "rfcrates_code",
            label: "RFC Rates",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "rfcmarkups_code",
            label: "RFC Markups",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "nextrfc_num",
            label: "Next RFC Number",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "directpay_code",
            label: "Direct Pay Code",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "pay_items",
            label: "Pay Items",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "lienwaivers",
            label: "Lien Waivers",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "lienwaivers_min",
            label: "Lien Waivers Min",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        // Phases & Categories
        {
            value: "contract_amount",
            label: "Contract Amount",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        // Payroll fields
        {
            value: "first_payroll_date",
            label: "First Payroll",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "work_location",
            label: "Work Location",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        // Document Management Fields
        {
            value: "contact_display_name",
            label: "Contact",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "owner_display_name",
            label: "Owner",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "contractor_display_name",
            label: "Contractor",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "engineer_display_name",
            label: "Engineer",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "architect_display_name",
            label: "Architect",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "manager_display_name",
            label: "Manager",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "submit_to_display_name",
            label: "Submit To",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "return_to_display_name",
            label: "Return To",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "submittal_quantity",
            label: "Submittal Quantity",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "supplier_quantity",
            label: "Supplier Quantity",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        {
            value: "default_days_to_respond",
            label: "Default Days To Respond",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        },
        //Notes fields
        {
            value: "notes",
            label: "Notes",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false
        }





    ],
    bJCCM: [
        {
            value: "Department",
            label: "Department",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false,
        },
        {
            value: "RetainagePCT",
            label: "RetainagePCT",
            description: "Dflt Retainage %",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false,
        },
        {
            value: "BillDayOfMth",
            label: "BillDayOfMth",
            description: "Bill Day",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false,
        },
        {
            value: "MarginPct",
            label: "MarginPct",
            description: "Margin %",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false,
        },
        {
            value: "TaxCode",
            label: "TaxCode",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false,
        },
        {
            value: "PayTerms",
            label: "PayTerms",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false,
        },
        {
            value: "DefaultBillType",
            label: "DefaultBillType",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false,
        },
        {
            value: "ContractStatus",
            label: "ContractStatus",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false,
        },
        {
            value: "MaxRetgOpt",
            label: "MaxRetgOpt",
            description: "Set WC Maximum Retention",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false,
        },{
            value: "MaxRetgPct",
            label: "MaxRetgPct",
            description: "% of Contract",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false,
        },
        {
            value: "MaxRetgAmt",
            label: "MaxRetgAmt",
            description: "Retainage Amount",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false,
        },
        {
            value: "StartMonth",
            label: "StartMonth",
            description: "Contract Start Month",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false,
        },
        {
            value: "ProjCloseDate",
            label: "ProjCloseDate",
            description: "Projected Completion Date",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false,
        },

        {
            value: "MaxRetgDistStyle",
            label: "MaxRetgDistStyle",
            description: "Adjust Maximum Bill",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false,
        },
        {
            value: "SIRegion",
            label: "SIRegion",
            description: "Std Region",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false,
        },
        {
            value: "OriginalDays",
            label: "OriginalDays",
            description: "Days In Contract Original",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false,
        },
        {
            value: "CurrentDays",
            label: "CurrentDays",
            description: "Days In Contract Current",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false,
        },
        {
            value: "ProcessGroup",
            label: "ProcessGroup",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false,
        },
        {
            value: "RecType",
            label: "RecType",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false,
        },
        {
            value: "MiscDistCode",
            label: "MiscDistCode",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false,
        },
        {
            value: "JBTemplate",
            label: "JBTemplate",
            description: "T&M Template",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false,
        },
        {
            value: "JBFlatBillingAmt",
            label: "JBFlatBillingAmt",
            description: "T&M Flat Bill Amtount",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false,
        },
        {
            value: "JBLimitOpt",
            label: "JBLimitOpt",
            description: "JB T&M Limit Option",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false,
        },
        {
            value: "RoundOpt",
            label: "RoundOpt",
            description: "Round Option",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false,
        },
        {
            value: "OrigContractAmt",
            label: "OrigContractAmt",
            description: "Total Orig. Contract",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false,
        },
        {
            value: "ContractAmt",
            label: "ContractAmt",
            description: "Total Curr. Contract",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false,
        },
        {
            value: "BillAddress",
            label: "BillAddress",
            description: "Address",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false,
        },
        {
            value: "BillAddress2",
            label: "BillAddress2",
            description: "Add'l Address",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false,
        },
        {
            value: "BillCity",
            label: "BillCity",
            description: "City",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false,
        },
        {
            value: "BillState",
            label: "BillState",
            description: "State",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false,
        },
        {
            value: "BillZip",
            label: "BillZip",
            description: "Zip Code",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false,
        },
        {
            value: "BillCountry",
            label: "BillCountry",
            description: "Country",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false,
        },{
            value: "BillNotes",
            label: "BillNotes",
            description: "JB Bill Notes",
            disabled: false,
            is_dropdown_field: false,
            options: null,
            required: false,
        },
        //Checkboxes
        {
            value: "SIMetric",
            label: "SIMetric",
            description: "Use Metric UM",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false,
        },
        {
            value: "BillOnCompletionYN",
            label: "BillOnCompletionYN",
            description: "Bill On Completion",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false,
        },
        {
            value: "ReportRetgItemYN",
            label: "ReportRetgItemYN",
            description: "Report Retainage at Item Level",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false,
        },
        {
            value: "TaxInterface",
            label: "TaxInterface",
            description: "Interface Taxes",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false,
        },
        {
            value: "InclACOinMaxYN",
            label: "InclACOinMaxYN",
            disabled: false,
            is_dropdown_field: true,
            options: null,
            required: false,
        }
    ],

};
export const erpOneWayFields = {
    JC_JOB_MASTER_MC : [
        'Superintendent'
    ],
    CR_CUSTOMER_MASTER_MC : [
        'Status', 'Salesperson'
    ],
    vSMWorkOrder : [
        'PRLocalCode', 'PRState', 'ServiceSite'
    ],
    jobs:[
        'estimator_no'
    ],
    job_chg:[
        'status'
    ],
    customers:[
    ],
    CR_CHNG_REQ_HDR_MC : [
        'job_total','Total_Cost', 'Submitted_Amount', 'Billing_Adjustment'
    ],
    bJCCM: [
        "Department", "RetainagePCT", "BillDayOfMth", "MarginPct", "TaxCode", "PayTerms", "DefaultBillType", "ContractStatus", "MaxRetgOpt", "MaxRetgPct", "MaxRetgAmt",
        "StartMonth", "ProjCloseDate", "MaxRetgDistStyle", "SIRegion", "OriginalDays", "CurrentDays", "ProcessGroup", "RecType", "MiscDistCode", "JBTemplate",
        "JBFlatBillingAmt", "JBLimitOpt", "RoundOpt", "OrigContractAmt", "ContractAmt", "BillAddress", "BillAddress2", "BillCity", "BillState", "BillZip", "BillCountry",
        "BillNotes", "SIMetric", "BillOnCompletionYN", "ReportRetgItemYN", "TaxInterface", "InclACOinMaxYN"
    ]
};
export const erpFieldsToHide = {
    vSMWorkOrder : [
        'JCCo', 'Job', 'SMCo', 'WorkOrderType','ServiceSite','ServiceCenter'
    ],
    Project : [
        'job_number'
    ],
    CE_jobs : [
        "uuid","company_uuid","wbs_type","approval_team_uuid","address2","address3","latitude",
        "longitude","radius","location_address","access_codes","customer_code","pay_items","lienwaivers",
        "contract_by_cat", "next_rfi_number","next_submittal_number","next_transmittal_number","certified_payroll","markup_percent_inventory",
        "markup_percent_labor","overhead_percent_labor","overhead_percent_unposted_labor","overhead_per_hour_labor","taxable_labor","markup_percent_overtime",
        "overhead_percent_overtime","overhead_percent_unposted_overtime","overhead_per_hour_overtime","taxable_overtime","overhead_percent_burden",
        "overhead_percent_fringes","markup_percent_material","overhead_percent_material","taxable_material","markup_percent_cost_type_6","overhead_percent_cost_type_6",
        "taxable_cost_type_6","markup_percent_cost_type_7","overhead_percent_cost_type_7","taxable_cost_type_7","markup_percent_cost_type_8",
        "overhead_percent_cost_type_8","taxable_cost_type_8","markup_percent_cost_type_9","overhead_percent_cost_type_9","taxable_cost_type_9",
        "markup_percent_cost_type_10","overhead_percent_cost_type_10","taxable_cost_type_10","markup_percent_cost_type_11","overhead_percent_cost_type_11",
        "taxable_cost_type_11","markup_percent_cost_type_12","overhead_percent_cost_type_12","taxable_cost_type_12","markup_percent_cost_type_13",
        "overhead_percent_cost_type_13","taxable_cost_type_13","markup_percent_cost_type_14","overhead_percent_cost_type_14","taxable_cost_type_14",
        "markup_percent_cost_type_15","overhead_percent_cost_type_15","taxable_cost_type_15","markup_percent_cost_type_16","overhead_percent_cost_type_16",
        "taxable_cost_type_16","user_field_values","original_contract_amount","created_at",
    ],
    bJCCM: [
        "JCCo", "Customer", "CustGroup", "TaxGroup", "BilledAmt", "ReceivedAmt", "CurrentRetainAmt", "InBatchMth", "InUseBatchId", "CompleteYN", "ProgressFormat",
        "TMFormat", "BillGroup", "UniqueAttchID", "OverProjNotes", "ClosePurgeFlag", "SecurityGroup", "UpdateJCCI", "KeyID", "PotentialProject",
        "AUUseTrustAccounts", "AUQualificationDate", "AUCMCo", "AUCMGeneralAcct", "AUCMRetentionAcct", "AUCMDisputedAcct"
    ]
};
export const spectrumCustomProjectIDState= [
    {
        "label": "Year",
        "id": "year",
        "value": true,
        "disable": false,
        "sequential": true,
        "start_from": false,
        "sequential_class": "sequential_year",
        "start_from_class": "start_from_year",
        "condition": true,
        "input_value": 2024,
        "input_type": 1,
    },
    {
        "label": "Month",
        "id": "month",
        "value": true,
        "disable": false,
        "sequential": true,
        "start_from": false,
        "sequential_class": "sequential_month",
        "start_from_class": "start_from_month",
        "condition": true,
        "input_value": 8,
        "input_type": 1,
    },
    {
        "label": "Day",
        "id": "day",
        "value": true,
        "disable": false,
        "sequential": true,
        "start_from": false,
        "sequential_class": "sequential_day",
        "start_from_class": "start_from_day",
        "condition": true,
        "input_value": 21,
        "input_type": 1,
    },
    {
        "label": "System Generated",
        "id": "system_generated",
        "value": true,
        "disable": false,
        "sequential": true,
        "start_from": false,
        "sequential_class": "sequential_system_generated",
        "start_from_class": "start_from_system_generated",
        "condition": true,
        "input_value": 1000,
        "input_type": 1,
    },
    {
        "label": "Other",
        "id": "other",
        "value": true,
        "disable": false,
        "sequential_class": "sequential_other",
        "start_from_class": "start_from_other",
        "condition": true,
        "seperated_by_dash": true,
        "seperated_by_space": false,
        "input_type": 0,
    }
]
export const sage300ProjectFields = [
        {is_dropdown_field: false, value:'id', label:'Project Seq ID/Custom #', disabled: false, object_type:'Project'},
        {is_dropdown_field: false, value:'job_number', label:'Auto-generated Job # based on Sage 300 Job # (N/A to alphanumeric)', disabled: false, object_type:'Project'},
        {is_dropdown_field: false, value:'name', label:'Name', disabled: false, object_type:'Project'},
        {is_dropdown_field: false, value:'address', label:'Address', disabled: false, object_type:'Project'},
        {is_dropdown_field: false, value:'city', label:'City', disabled: false, object_type:'Project'},
        {is_dropdown_field: false, value:'state', label:'State', disabled: false, object_type:'Project'},
        {is_dropdown_field: false, value:'zip', label:'Zip Code', disabled: false, object_type:'Project'},
        {is_dropdown_field: false, value:'base_bid', label:'Base Bid', disabled: false, object_type:'Project'},
        {is_dropdown_field: false, value:'contract_amount', label:'Contract Amount', disabled: false, object_type:'Project'},
        {is_dropdown_field: false, value:'contract_date', label:'Contract Date', disabled: false, object_type:'Project'},
        {is_dropdown_field: false, value:'bid_date', label:'Bid Date', disabled: false, object_type:'Project'},
        {is_dropdown_field: false, value:'pre_bid', label:'Pre Bid', disabled: false, object_type:'Project'},
        {is_dropdown_field: true, value:'sales_status_id', label:'Sales Status', disabled: false, object_type:'Project'},
        {is_dropdown_field: true, value:'marketing_status_id', label:'Marketing Status', disabled: false, object_type:'Project'},
        {is_dropdown_field: true, value:'lead_from_id', label:'Lead From', disabled: false, object_type:'Project'},
        {is_dropdown_field: true, value:'account_manager_id', label:'Account Manager', disabled: false, object_type:'Project'},
        {is_dropdown_field: true, value:'estimator_id', label:'Estimator', disabled: false, object_type:'Project'},
        {is_dropdown_field: true, value:'take_off_person_id', label:'Take Off Person', disabled: false, object_type:'Project'},
        {is_dropdown_field: true, value:'client_profile_id', label:'Client Profile', disabled: false, object_type:'Project'},
        {is_dropdown_field: true, value:'contract_type_id', label:'Contract Type', disabled: false, object_type:'Project'},
        {is_dropdown_field: false, value:'estimated_contract_date', label:'Estimated Contract Date', disabled: false, object_type:'Project'},
        {is_dropdown_field: true, value:'products_and_services_id', label:'Products & Services', disabled: false, object_type:'Project'},
        {is_dropdown_field: false, value:'gross_margin_percentage', label: "Gross Margin %", disabled: false, object_type: "Project"},
        {is_dropdown_field: false, value:'labor_hours', label: "Labor Hours", disabled: false, object_type: "Project"},
        {is_dropdown_field: true, value:'office_id', label: "Office/Location", disabled: false, object_type: "Project"},
        {is_dropdown_field: false, value:'project_comment', label: "Project Comment", disabled: false, object_type: "Project", is_project_comment: true}
];

export const sage300ProjectContactFields = [
    { label: "Project Contact Name", value: "project_contact_name", disabled: false, object_type: "Project", is_custom_field: false, is_record_detail_custom_field: false, is_dropdown_field: false, is_project_contact:true, options: null},
    { label: "Phone", value: "phone", disabled: false, object_type: "Project", is_custom_field: false, is_record_detail_custom_field: false, is_dropdown_field: false, is_project_contact:true, options: null},
    { label: "Fax", value: "fax", disabled: false, object_type: "Project", is_custom_field: false, is_record_detail_custom_field: false, is_dropdown_field: false, is_project_contact:true, options: null},
    { label: "Cell", value: "cell", disabled: false, object_type: "Project", is_custom_field: false, is_record_detail_custom_field: false, is_dropdown_field: false, is_project_contact:true, options: null},
    { label: "Email", value: "email", disabled: false, object_type: "Project", is_custom_field: false, is_record_detail_custom_field: false, is_dropdown_field: false, is_project_contact:true, options: null},
];


export const sage300ContactFields = [
    {is_dropdown_field: false, value:'id', label:'Contact ID', disabled: false, object_type:'CompanyContact'},
    {is_dropdown_field: false, value:'number', label:'Auto-generated Contact Code # based on Sage 300 Contacts (N/A to alphanumeric)', disabled: false, object_type:'CompanyContact'},
    {is_dropdown_field: false, value:'name', label:'Name', disabled: false, object_type:'CompanyContact'},
    {is_dropdown_field: false, value:'email', label:'Email', disabled: false, object_type:'CompanyContact'},
    {is_dropdown_field: false, value:'cell', label:'Cell', disabled: false, object_type:'CompanyContact'},
    {is_dropdown_field: false, value:'title', label:'Title', disabled: false, object_type:'CompanyContact'},
    {is_dropdown_field: true, value:'contact_types_id', label:'Contact Type', disabled: false, object_type:'CompanyContact'},
    {is_dropdown_field: true, value: "team_contact_status", label: "Status", disabled: false, object_type: "CompanyContact"},
    {is_dropdown_field: true, value: "user_id", label: "User", disabled: false, object_type: "CompanyContact"}

];

export const sage300CompanyFields = [
    {is_dropdown_field: false, value:'id', label:'Company ID', disabled: false, object_type:'Company'},
    {is_dropdown_field: false, value:'number', label:'Auto-generated Customer Code # based on Sage 300 Customers (N/A to alphanumeric)', disabled: false, object_type:'Company'},
    {is_dropdown_field: false, value:'name', label:'Name', disabled: false, object_type:'Company'},
    {is_dropdown_field: false, value:'address', label:'Address', disabled: false, object_type:'Company'},
    {is_dropdown_field: false, value:'city', label:'City', disabled: false, object_type:'Company'},
    {is_dropdown_field: false, value:'state', label:'State', disabled: false, object_type:'Company'},
    {is_dropdown_field: false, value:'zip', label:'Zip Code', disabled: false, object_type:'Company'},
    {is_dropdown_field: false, value:'phone', label:'Phone', disabled: false, object_type:'Company'},
    {is_dropdown_field: false, value:'fax', label:'Fax', disabled: false, object_type:'Company'},
    {is_dropdown_field: false, value:'site', label:'Web Site', disabled: false, object_type:'Company'},
    {is_dropdown_field: true, value:'company_types_id', label:'Company Type', disabled: false, object_type:'Company'},
    {is_dropdown_field: true, value: "team_company_status", label: "Status", disabled: false, object_type: "Company"}
];

export const sage300AgaveFields = {
    'MASTER_JCM_RECORD_1': [
        {value:'name', label:'JDESC', description: 'Name', disabled: false, required: true, direction: 'two-ways'},
        {value:'job_code', label:'JOB', description: 'Job Number', disabled: false, required: true, direction: 'two-ways'},
        {value:'street_1', label:'JADDR1', description: 'Address 1', disabled: false, required: false, direction: 'two-ways'},
        {value:'street_2', label:'JADDR2', description: 'Address 2', disabled: false, required: false, direction: 'two-ways'},
        {value:'city', label:'JCITY', description: 'City',disabled: false, required: false, direction: 'two-ways'},
        {value:'state', label:'JSTATE', description: 'State', disabled: false, required: false, direction: 'two-ways'},
        {value:'postal_code', label:'JZIP', description: 'Postal Code', disabled: false, required: false, direction: 'two-ways'},
        {value:'amount', label:'JRVCNT', description: 'Amount', disabled: false, required: false, direction: 'two-ways'},
        {value:'description', label:'JSCOPE', description: 'Scope of work', disabled: false, required: false, direction: 'two-ways'},
        {value:'start_date', label:'JESTSD', description: 'Estimated Start Date', disabled: false, required: false, direction: 'two-ways'},
        {value:'completion_date', label:'JESTCD', description: 'Estimated Completion Date', disabled: false, required: false, direction: 'two-ways'},
        {value:'status', label:'JSTATUS', description: 'Status', disabled: false, required: false, direction: 'two-ways'},
        {value:'type', label:'JTYPE', description: 'Type', disabled: false, required: false, direction: 'two-ways'},

        {value:'JSIZE', label:'JSIZE', description: 'Job Size', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JUDESC', label:'JUDESC', description: 'Unit Desc', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JSECID', label:'JSECID', description: 'Security ID', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCOMETH', label:'JCOMETH', description: 'Use PJ Change Management', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JSPHN', label:'JSPHN', description: 'Site Phone', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JFPHN', label:'JFPHN', description: 'Fax', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPHN', label:'JPHN', description: 'Misc. phone', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPRJMGR', label:'JPRJMGR', description: 'Project Manager', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JTITL1', label:'JTITL1', description: 'Estimator', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JTITL2', label:'JTITL2', description: 'GC', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JTITL3', label:'JTITL3', description: 'Inspector', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JTITL4', label:'JTITL4', description: 'Owner', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPMEML', label:'JPMEML', description: 'Project Manager Email', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JSPEML', label:'JSPEML', description: 'Superintendent Email', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JORDER1', label:'JORDER1', description: 'Proj Mgr Sort', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JORDER2', label:'JORDER2', description: 'User Def Key 2', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JEXTRAS', label:'JEXTRAS', description: 'Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JREVSD', label:'JREVSD', description: 'Revised Start Date', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JREVCD', label:'JREVCD', description: 'Revised Completion Date', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JACTSD', label:'JACTSD', description: 'Actual Start Date', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JACTCD', label:'JACTCD', description: 'Actual Completion Date', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLCUPD', label:'JLCUPD', description: 'Last Cost Update', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCLST1', label:'JCLST1', description: 'Obtained Plans', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCLST2', label:'JCLST2', description: 'Reviewed Plans', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCLST3', label:'JCLST3', description: 'Check Req', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCLST4', label:'JCLST4', description: 'Schedule Req', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCLST5', label:'JCLST5', description: 'Order Shop Dwgs', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCLST6', label:'JCLST6', description: 'Mat Procurement', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCLST7', label:'JCLST7', description: 'Tool Procure', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCLST8', label:'JCLST8', description: 'Checklist 8', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCLST9', label:'JCLST9', description: 'Checklist 9', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCLST10', label:'JCLST10', description: 'Checklist 10', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCLST11', label:'JCLST11', description: 'Checklist 11', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCLST12', label:'JCLST12', description: 'Checklist 12', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JARCUST', label:'JARCUST', description: 'AR Customer', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JARTGRP', label:'JARTGRP', description: 'AR Tax Group', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JBMETH', label:'JBMETH', description: 'Billing Method', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JBLEVEL', label:'JBLEVEL', description: 'Billing Level', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JREVACT', label:'JREVACT', description: 'Revenue Account', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JRTNPCT', label:'JRTNPCT', description: 'Retainage Percent', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JEXFC', label:'JEXFC', description: 'Exempt from finance charge', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JFCTYPE', label:'JFCTYPE', description: 'Finance Charge Type', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JFCPCNT', label:'JFCPCNT', description: 'Finance Charge Percentage', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JFCFLAT', label:'JFCFLAT', description: 'Finance Charge Flat Rate', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCERT', label:'JCERT', description: 'Payroll daily entry control', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JWCGRP', label:'JWCGRP', description: 'Worker"s comp group', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JBURPCT', label:'JBURPCT', description: 'Burden percent', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JWRKST', label:'JWRKST', description: 'State', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JWRKCTY', label:'JWRKCTY', description: 'Local', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JERCODE', label:'JERCODE', description: 'Default revenue code', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCRTPRJ', label:'JCRTPRJ', description: 'Certified Project', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JHOLD', label:'JHOLD', description: 'Job On Hold', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JAUTH', label:'JAUTH', description: 'Approval ID', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JAPBANK', label:'JAPBANK', description: 'AP Bank', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLTXGRP', label:'JLTXGRP', description: 'Tax Group Labor', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JMTXGRP', label:'JMTXGRP', description: 'Tax Group Material', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JSTXGRP', label:'JSTXGRP', description: 'Tax Group Subcontract', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JETXGRP', label:'JETXGRP', description: 'Tax Group Equipment', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JBTXGRP', label:'JBTXGRP', description: 'Tax Group Overhead', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JOTXGRP', label:'JOTXGRP', description: 'Tax Group Other', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCAGRP', label:'JCAGRP', description: 'Cost Account Group', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPREFIX', label:'JPREFIX', description: 'GL Account Prefix', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCSTACC', label:'JCSTACC', description: 'Cost Account', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCOSACC', label:'JCOSACC', description: 'Cost of Sales Account', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JREVACC', label:'JREVACC', description: 'Full Revenue Account', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JRVRMTH', label:'JRVRMTH', description: 'Revenue Recognition', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCPSLW', label:'JCPSLW', description: 'Generate Lien Waiver (Subcontractor)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCUSCLA', label:'JCUSCLA', description: 'Use Minimum Commitment (Subcontractor)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCMLSCA', label:'JCMLSCA', description: 'Minimum Commitment Ammount (Subcontractor)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCMLWSA', label:'JCMLWSA', description: 'Minimum Lien Waiver Ammount (Subcontractor)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCRSCR', label:'JCRSCR', description: 'Require Certified Reports (Subcontractor)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCRSMA', label:'JCRSMA', description: 'Require Final Compl. Approval (Subcontractor)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCPPLW', label:'JCPPLW', description: 'Generate Lien Waiver (Supplier)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCUPCLA', label:'JCUPCLA', description: 'Use Minimum Commitment (Supplier)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCMLPCA', label:'JCMLPCA', description: 'Minimum Commitment Ammount (Supplier)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCMLWPA', label:'JCMLWPA', description: 'Minimum Lien Waiver Ammount (Supplier)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCRPCR', label:'JCRPCR', description: 'Require Certified Reports (Supplier)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCRPMA', label:'JCRPMA', description: 'Require Final Compl. Approval (Supplier)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCPOLW', label:'JCPOLW', description: 'Generate Lien Waiver (Other)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCUOCLA', label:'JCUOCLA', description: 'Use Minimum Commitment (Other)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCMLOCA', label:'JCMLOCA', description: 'Minimum Commitment Ammount (Other)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCMLWOA', label:'JCMLWOA', description: 'Minimum Lien Waiver Ammount (Other)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCROCR', label:'JCROCR', description: 'Require Certified Reports (Other)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCROMA', label:'JCROMA', description: 'Require Final Compl. Approval (Other)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCPELW', label:'JCPELW', description: 'Generate Lien Waiver (Equip Supplier)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCUECLA', label:'JCUECLA', description: 'Use Minimum Commitment (Equip Supplier)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCMLECA', label:'JCMLECA', description: 'Minimum Commitment Ammount (Equip Supplier)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCMLWEA', label:'JCMLWEA', description: 'Minimum Lien Waiver Ammount (Equip Supplier)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCRECR', label:'JCRECR', description: 'Require Certified Reports (Equip Supplier)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCREMA', label:'JCREMA', description: 'Require Final Compl. Approval (Equip Supplier)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCLWCTD', label:'JCLWCTD', description: 'Conditional Lien Waivers', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCLDOM', label:'JCLDOM', description: 'Last day of month', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCLWUTD', label:'JCLWUTD', description: 'Unconditional Lien Waivers', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCJUR', label:'JCJUR', description: 'Jurisdiction', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCDWEND', label:'JCDWEND', description: 'Day of Week ending for Certified Reports', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCMCTOL', label:'JCMCTOL', description: 'Final compliance approval percentage', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCUST', label:'JCUST', description: 'Customer', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCNAME', label:'JCNAME', description: 'Customer Name', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCADDR1', label:'JCADDR1', description: 'Customer Address 1', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCADDR2', label:'JCADDR2', description: 'Customer Address 2', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCCITY', label:'JCCITY', description: 'Customer City', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCSTATE', label:'JCSTATE', description: 'Customer State', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCZIP', label:'JCZIP', description: 'Customer Zip', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCCONT1', label:'JCCONT1', description: 'Customer Contact 1', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCPHN1', label:'JCPHN1', description: 'Customer Phone 1', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCFAX', label:'JCFAX', description: 'Customer FAX #', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JBADDR1', label:'JBADDR1', description: 'Bill to Address 1', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JBADDR2', label:'JBADDR2', description: 'Bill to Address 2', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JBCITY', label:'JBCITY', description: 'Bill to city', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JBSTATE', label:'JBSTATE', description: 'Bill to state', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JBZIP', label:'JBZIP', description: 'Bill to zip Code', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCCONT2', label:'JCCONT2', description: 'Customer Contact 2', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCPHN2', label:'JCPHN2', description: 'Customer Phone 2', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JOWNCNT', label:'JOWNCNT', description: 'Owner Contract ID', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCDATE', label:'JCDATE', description: 'Contract Date', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JRETPCT', label:'JRETPCT', description: 'Contract Retainage Percnt', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCTYPE', label:'JCTYPE', description: 'Contract Type', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JOCNT', label:'JOCNT', description: 'Original Contract Amount', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPCNTC', label:'JPCNTC', description: 'Potential Changes Amount', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPCNTC2', label:'JPCNTC2', description: 'Submitted Changes Amount', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPCNTC3', label:'JPCNTC3', description: 'Verbal okay Changes Amount', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JACNTC', label:'JACNTC', description: 'Approved Changes Amount', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JRVCNT', label:'JRVCNT', description: 'Revised contract Amount', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JYTDACN', label:'JYTDACN', description: 'Year to date Approval Totals', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JQTDACN', label:'JQTDACN', description: 'Quarter to date Approval Totals', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JMTDACN', label:'JMTDACN', description: 'Month to date Approval Totals', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLMACN', label:'JLMACN', description: 'Last Month Approval Totals', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JNMACN', label:'JNMACN', description: 'Next Month Approval Totals', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDWB', label:'JJTDWB', description: 'Job to date (Work Billed)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JYTDWB', label:'JYTDWB', description: 'Year to date (Work Billed)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JQTDWB', label:'JQTDWB', description: 'Quarter to date (Work Billed)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JMTDWB', label:'JMTDWB', description: 'Month to date (Work Billed)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLMWB', label:'JLMWB', description: 'Last Month (Work Billed)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JNMWB', label:'JNMWB', description: 'Next Month (Work Billed)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDRH', label:'JJTDRH', description: 'Job to date (Retainage Held)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JYTDRH', label:'JYTDRH', description: 'Year to date (Retainage Held)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JQTDRH', label:'JQTDRH', description: 'Quarter to date (Retainage Held)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JMTDRH', label:'JMTDRH', description: 'Month to date (Retainage Held)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLMRH', label:'JLMRH', description: 'Last Month (Retainage Held)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JNMRH', label:'JNMRH', description: 'Next Month (Retainage Held)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDPY', label:'JJTDPY', description: 'Job to date (Payments)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JYTDPY', label:'JYTDPY', description: 'Year to date (Payments)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JQTDPY', label:'JQTDPY', description: 'Quarter to date (Payments)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JMTDPY', label:'JMTDPY', description: 'Month to date (Payments)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLMPY', label:'JLMPY', description: 'Last Month (Payments)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JNMPY', label:'JNMPY', description: 'Next Month (Payments)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDADJ', label:'JJTDADJ', description: 'Job to date (Adjustments)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JYTDADJ', label:'JYTDADJ', description: 'Year to date (Adjustments)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JQTDADJ', label:'JQTDADJ', description: 'Quarter to date (Adjustments)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JMTDADJ', label:'JMTDADJ', description: 'Month to date (Adjustments)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLMADJ', label:'JLMADJ', description: 'Last Month (Adjustments)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JNMADJ', label:'JNMADJ', description: 'Next Month (Adjustments)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JBLBAL', label:'JBLBAL', description: 'Receivable Balance', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLSTDRR', label:'JLSTDRR', description: 'Last Draw', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JOESTFN', label:'JOESTFN', description: 'Original Estimate Finalized', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JOEST', label:'JOEST', description: 'Original (Estimated Cost)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPESTC', label:'JPESTC', description: 'Pending Charges', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JAESTC', label:'JAESTC', description: 'Approved Charges', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JTEST', label:'JTEST', description: 'Total', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JYTDAES', label:'JYTDAES', description: 'Year to date (Approved Totals)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JQTDAES', label:'JQTDAES', description: 'Quarter to date', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JMTDAES', label:'JMTDAES', description: 'Month to date', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLMAES', label:'JLMAES', description: 'Last Month', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JNMAES', label:'JNMAES', description: 'Next Month', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JOCOM', label:'JOCOM', description: 'Original Commitments (Cost Totals)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPCOMC', label:'JPCOMC', description: 'Pending Charges Commitments', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JACOMC', label:'JACOMC', description: 'Approval Charges Commitments', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JRVCOM', label:'JRVCOM', description: 'Total Commitments', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCOMI', label:'JCOMI', description: 'Total Commitments Invoiced', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDC', label:'JJTDC', description: 'Job to date (Cost)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JYTDC', label:'JYTDC', description: 'Year to date (Cost)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JQTDC', label:'JQTDC', description: 'Quarter to date (Cost)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JMTDC', label:'JMTDC', description: 'Month to date (Cost)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLMC', label:'JLMC', description: 'Last Month (Cost)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JNMC', label:'JNMC', description: 'Next Month (Cost)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPTDC', label:'JPTDC', description: 'Week to date (Cost)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLPC', label:'JLPC', description: 'Last Week (Cost)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDCT', label:'JJTDCT', description: 'JJTDCT', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JYTDCT', label:'JYTDCT', description: 'JYTDCT', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JQTDCT', label:'JQTDCT', description: 'JQTDCT', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JMTDCT', label:'JMTDCT', description: 'JMTDCT', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLMCT', label:'JLMCT', description: 'JLMCT', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JNMCT', label:'JNMCT', description: 'JNMCT', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPTDCT', label:'JPTDCT', description: 'JPTDCT', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLPCT', label:'JLPCT', description: 'JLPCT', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDDP', label:'JJTDDP', description: 'Job to date (Dollars Paid)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JYTDDP', label:'JYTDDP', description: 'Year to date (Dollars Paid)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JQTDDP', label:'JQTDDP', description: 'Quarter to date (Dollars Paid)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JMTDDP', label:'JMTDDP', description: 'Month to date (Dollars Paid)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLMDP', label:'JLMDP', description: 'Last Month (Dollars Paid)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JNMDP', label:'JNMDP', description: 'Next Month (Dollars Paid)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPTDDP', label:'JPTDDP', description: 'Week to date (Dollars Paid)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLPDP', label:'JLPDP', description: 'Last Week (Dollars Paid)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDDPT', label:'JJTDDPT', description: 'JJTDDPT', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JYTDDPT', label:'JYTDDPT', description: 'JYTDDPT', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JQTDDPT', label:'JQTDDPT', description: 'JQTDDPT', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JMTDDPT', label:'JMTDDPT', description: 'JMTDDPT', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLMDPT', label:'JLMDPT', description: 'JLMDPT', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JNMDPT', label:'JNMDPT', description: 'JNMDPT', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPTDDPT', label:'JPTDDPT', description: 'JPTDDPT', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLPDPT', label:'JLPDPT', description: 'JLPDPT', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JTXAMT', label:'JTXAMT', description: 'Total Taxes', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JTLEST', label:'JTLEST', description: 'Labor Total Estimates (Accumulation Totals)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLUEST', label:'JLUEST', description: 'Labor Units Total Estimates', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JTMEST', label:'JTMEST', description: 'Material Total Estimates', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JTSEST', label:'JTSEST', description: 'Subcontract Total Estimates', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JTEEST', label:'JTEEST', description: 'Equipment Total Estimates', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JEUEST', label:'JEUEST', description: 'Equipment units Total Estimates', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JTBEST', label:'JTBEST', description: 'Overhead Total Estimates', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JTOEST', label:'JTOEST', description: 'Other Total Estimates', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JTLCOM', label:'JTLCOM', description: 'Labor Total Commitments', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JTMCOM', label:'JTMCOM', description: 'Material Total Commitments', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JTSCOM', label:'JTSCOM', description: 'Subcontract Total Commitments', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JTECOM', label:'JTECOM', description: 'Equipment Total Commitments', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JTBCOM', label:'JTBCOM', description: 'Overhead Total Commitments', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JTOCOM', label:'JTOCOM', description: 'Other Total Commitments', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCOMIL', label:'JCOMIL', description: 'Labor Commitments Invoiced', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCOMIM', label:'JCOMIM', description: 'Material Commitments Invoiced', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCOMIS', label:'JCOMIS', description: 'Subcontract Commitments Invoiced', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCOMIE', label:'JCOMIE', description: 'Equipment Commitments Invoiced', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCOMIB', label:'JCOMIB', description: 'Overhead Commitments Invoiced', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCOMIO', label:'JCOMIO', description: 'Other Commitments Invoiced', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDLC', label:'JJTDLC', description: 'Job to date (Labor) Accumulation Period Totals', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDLU', label:'JJTDLU', description: 'Job to date (Labor Units)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDMC', label:'JJTDMC', description: 'Job to date (Material)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDSC', label:'JJTDSC', description: 'Job to date (Subcontract)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDEC', label:'JJTDEC', description: 'Job to date (Equipment)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDEU', label:'JJTDEU', description: 'Job to date (Equipment Units)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDBC', label:'JJTDBC', description: 'Job to date (Overhead)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDOC', label:'JJTDOC', description: 'Job to date (Other)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JMTDLC', label:'JMTDLC', description: 'Month to date (Labor) Accumulation Period Totals', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JMTDLU', label:'JMTDLU', description: 'Month to date (Labor Units)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JMTDMC', label:'JMTDMC', description: 'Month to date (Material)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JMTDSC', label:'JMTDSC', description: 'Month to date (Subcontract)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JMTDEC', label:'JMTDEC', description: 'Month to date (Equipment)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JMTDEU', label:'JMTDEU', description: 'Month to date (Equipment Units)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JMTDBC', label:'JMTDBC', description: 'Month to date (Overhead)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JMTDOC', label:'JMTDOC', description: 'Month to date (Other)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLMLC', label:'JLMLC', description: 'Last month (Labor) Accumulation Period Totals', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLMLU', label:'JLMLU', description: 'Last month (Labor Units)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLMMC', label:'JLMMC', description: 'Last month (Material)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLMSC', label:'JLMSC', description: 'Last month (Subcontract)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLMEC', label:'JLMEC', description: 'Last month (Equipment)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLMEU', label:'JLMEU', description: 'Last month (Equipment Units)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLMBC', label:'JLMBC', description: 'Last month (Overhead)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLMOC', label:'JLMOC', description: 'Last month (Other)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JNMLC', label:'JNMLC', description: 'Next Month (Labor) Accumulation Period Totals', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JNMLU', label:'JNMLU', description: 'Next Month (Labor Units)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JNMMC', label:'JNMMC', description: 'Next Month (Material)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JNMSC', label:'JNMSC', description: 'Next Month (Subcontract)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JNMEC', label:'JNMEC', description: 'Next Month (Equipment)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JNMEU', label:'JNMEU', description: 'Next Month (Equipment Units)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JNMBC', label:'JNMBC', description: 'Next Month (Overhead)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JNMOC', label:'JNMOC', description: 'Next Month (Other)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPTDLC', label:'JPTDLC', description: 'Week to date (Labor)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPTDLU', label:'JPTDLU', description: 'Week to date (Labor Units)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPTDEC', label:'JPTDEC', description: 'Week to date (Equipment)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPTDEU', label:'JPTDEU', description: 'Week to date (Equipment Units)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDLDP', label:'JJTDLDP', description: 'Labor (Dollars Paid)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDMDP', label:'JJTDMDP', description: 'Material', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDSDP', label:'JJTDSDP', description: 'Subcontract', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDEDP', label:'JJTDEDP', description: 'Equipment', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDBDP', label:'JJTDBDP', description: 'Overhead', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDODP', label:'JJTDODP', description: 'Other', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLRDATE', label:'JLRDATE', description: 'Date of last report date (MW and Custom Total)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPCTCP', label:'JPCTCP', description: 'Percent complete', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJFAM1', label:'JJFAM1', description: 'Msc job amt 1', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJFAM2', label:'JJFAM2', description: 'Msc job amt 2', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJFAM3', label:'JJFAM3', description: 'Msc job amt 3', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPFAM1', label:'JPFAM1', description: 'Stored Material', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPFAM2', label:'JPFAM2', description: 'Cost at Comp', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPFAM3', label:'JPFAM3', description: 'Cost to Comp', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPFAM4', label:'JPFAM4', description: 'Lab Hrs to Comp', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPFAM5', label:'JPFAM5', description: 'Msc CC amt 5', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPFAM6', label:'JPFAM6', description: 'Msc CC amt 6', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCFAM1', label:'JCFAM1', description: 'Msc cat amt 1', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCFAM2', label:'JCFAM2', description: 'Msc cat amt 2', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCFAM3', label:'JCFAM3', description: 'Msc cat amt 3', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCFAM4', label:'JCFAM4', description: 'Msc cat amt 4', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JFRMT1', label:'JFRMT1', description: 'Custom total 1', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JFRMT2', label:'JFRMT2', description: 'Custom total 2', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JFRMT3', label:'JFRMT3', description: 'Custom total 3', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JFRMT4', label:'JFRMT4', description: 'Custom total 4', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JFRMT5', label:'JFRMT5', description: 'Custom total 5', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JFRMT6', label:'JFRMT6', description: 'Custom total 6', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JFRMDTE', label:'JFRMDTE', description: 'Last custom total update date', disabled: false, required: false, direction: 'one-way-followup'},

        {value:'JXOCNT', label:'JXOCNT', description: 'Original Contract Amount (Extras)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXPCNTC', label:'JXPCNTC', description: 'Potential Changes Amount (Extras)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXPCNT2', label:'JXPCNT2', description: 'Submitted Changes Amount (Extras)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXPCNT3', label:'JXPCNT3', description: 'Verbal okay Changes Amount (Extras)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXACNTC', label:'JXACNTC', description: 'Approved Changes Amount (Extras)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXRVCNT', label:'JXRVCNT', description: 'Revised contract Amount (Extras)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXYTDAC', label:'JXYTDAC', description: 'Year to date Approval Totals (Extras)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXQTDAC', label:'JXQTDAC', description: 'Quarter to date Approval Totals (Extras)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXMTDAC', label:'JXMTDAC', description: 'Month to date Approval Totals (Extras)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXLMAC', label:'JXLMAC', description: 'Last Month Approval Totals (Extras)', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXNMAC', label:'JXNMAC', description: 'Next Month Approval Totals (Extras)', disabled: false, required: false, direction: 'one-way-followup'},

        {value:'JXJTDWB', label:'JXJTDWB', description: 'Job to date (Work Billed) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXYTDWB', label:'JXYTDWB', description: 'Year to date (Work Billed) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXQTDWB', label:'JXQTDWB', description: 'Quarter to date (Work Billed) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXMTDWB', label:'JXMTDWB', description: 'Month to date (Work Billed) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXLMWB', label:'JXLMWB', description: 'Last Month (Work Billed) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXNMWB', label:'JXNMWB', description: 'Next Month (Work Billed) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXJTDRH', label:'JXJTDRH', description: 'Job to date (Retainage Held) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXYTDRH', label:'JXYTDRH', description: 'Year to date (Retainage Held) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXQTDRH', label:'JXQTDRH', description: 'Quarter to date (Retainage Held) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXMTDRH', label:'JXMTDRH', description: 'Month to date (Retainage Held) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXLMRH', label:'JXLMRH', description: 'Last Month (Retainage Held) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXNMRH', label:'JXNMRH', description: 'Next Month (Retainage Held) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXJTDPY', label:'JXJTDPY', description: 'Job to date (Payments) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXYTDPY', label:'JXYTDPY', description: 'Year to date (Payments) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXQTDPY', label:'JXQTDPY', description: 'Quarter to date (Payments) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXMTDPY', label:'JXMTDPY', description: 'Month to date (Payments) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXLMPY', label:'JXLMPY', description: 'Last Month (Payments) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXNMPY', label:'JXNMPY', description: 'Next Month (Payments) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXJTDAD', label:'JXJTDAD', description: 'Job to date (Adjustments) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXYTDAD', label:'JXYTDAD', description: 'Year to date (Adjustments) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXQTDAD', label:'JXQTDAD', description: 'Quarter to date (Adjustments) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXMTDAD', label:'JXMTDAD', description: 'Month to date (Adjustments) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXLMAD', label:'JXLMAD', description: 'Last Month (Adjustments) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXNMAD', label:'JXNMAD', description: 'Next Month (Adjustments) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXBLBAL', label:'JXBLBAL', description: 'Receivable Balance - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JOXEST', label:'JOXEST', description: 'Original (Estimated Cost) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPXEST', label:'JPXEST', description: 'Pending Charges - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JAXEST', label:'JAXEST', description: 'Approved Charges - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JTXEST', label:'JTXEST', description: 'Total - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JAXYTDE', label:'JAXYTDE', description: 'Year to date (Approved Totals) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JAXQTDE', label:'JAXQTDE', description: 'Quarter to date - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JAXMTDE', label:'JAXMTDE', description: 'Month to date - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JAXLME', label:'JAXLME', description: 'Last Month - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JAXNME', label:'JAXNME', description: 'Next Month - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JOXCOM', label:'JOXCOM', description: 'Original Commitments (Cost Totals) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPXCOM', label:'JPXCOM', description: 'Pending Charges Commitments - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JAXCOM', label:'JAXCOM', description: 'Approval Charges Commitments - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JRVXCOM', label:'JRVXCOM', description: 'Total Commitments - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCOMXI', label:'JCOMXI', description: 'Total Commitments Invoiced - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDXC', label:'JJTDXC', description: 'Job to date (Cost) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JYTDXC', label:'JYTDXC', description: 'Year to date (Cost) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JQTDXC', label:'JQTDXC', description: 'Quarter to date (Cost) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JMTDXC', label:'JMTDXC', description: 'Month to date (Cost) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLMXC', label:'JLMXC', description: 'Last Month (Cost) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JNMXC', label:'JNMXC', description: 'Next Month (Cost) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPTDXC', label:'JPTDXC', description: 'Week to date (Cost) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLPXC', label:'JLPXC', description: 'Last Week (Cost) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDXCT', label:'JJTDXCT', description: 'JJTDXCT - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JYTDXCT', label:'JYTDXCT', description: 'JYTDXCT - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JQTDXCT', label:'JQTDXCT', description: 'JQTDXCT - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JMTDXCT', label:'JMTDXCT', description: 'JMTDXCT - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLMXCT', label:'JLMXCT', description: 'JLMXCT - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JNMXCT', label:'JNMXCT', description: 'JNMXCT - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPTDXCT', label:'JPTDXCT', description: 'JPTDXCT - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLPXCT', label:'JLPXCT', description: 'JLPXCT - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDXDP', label:'JJTDXDP', description: 'Job to date (Dollars Paid) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JYTDXDP', label:'JYTDXDP', description: 'Year to date (Dollars Paid) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JQTDXDP', label:'JQTDXDP', description: 'Quarter to date (Dollars Paid) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JMTDXDP', label:'JMTDXDP', description: 'Month to date (Dollars Paid) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLMXDP', label:'JLMXDP', description: 'Last Month (Dollars Paid) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JNMXDP', label:'JNMXDP', description: 'Next Month (Dollars Paid) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPTDXDP', label:'JPTDXDP', description: 'Week to date (Dollars Paid) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLPXDP', label:'JLPXDP', description: 'Last Week (Dollars Paid) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDXDT', label:'JJTDXDT', description: 'JJTDXDT - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JYTDXDT', label:'JYTDXDT', description: 'JYTDXDT - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JQTDXDT', label:'JQTDXDT', description: 'JQTDXDT - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JMTDXDT', label:'JMTDXDT', description: 'JMTDXDT - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLMXDPT', label:'JLMXDPT', description: 'JLMXDPT - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JNMXDPT', label:'JNMXDPT', description: 'JNMXDPT - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPTDXDT', label:'JPTDXDT', description: 'JPTDXDT - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLPXDPT', label:'JLPXDPT', description: 'JLPXDPT - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JTXXAMT', label:'JTXXAMT', description: 'Total Taxes - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JTXLEST', label:'JTXLEST', description: 'Labor Total Estimates (Accumulation Totals) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JAXLUES', label:'JAXLUES', description: 'Labor Units Total Estimates - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JTXMEST', label:'JTXMEST', description: 'Material Total Estimates - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JTXSEST', label:'JTXSEST', description: 'Subcontract Total Estimates - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JTXEEST', label:'JTXEEST', description: 'Equipment Total Estimates - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JAXEUES', label:'JAXEUES', description: 'Equipment units Total Estimates - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JTXBEST', label:'JTXBEST', description: 'Overhead Total Estimates - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JTXOEST', label:'JTXOEST', description: 'Other Total Estimates - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JTXLCOM', label:'JTXLCOM', description: 'Labor Total Commitments - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JTXMCOM', label:'JTXMCOM', description: 'Material Total Commitments - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JTXSCOM', label:'JTXSCOM', description: 'Subcontract Total Commitments - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JTXECOM', label:'JTXECOM', description: 'Equipment Total Commitments - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JTXBCOM', label:'JTXBCOM', description: 'Overhead Total Commitments - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JTXOCOM', label:'JTXOCOM', description: 'Other Total Commitments - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCOMXIL', label:'JCOMXIL', description: 'Labor Commitments Invoiced - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCOMXIM', label:'JCOMXIM', description: 'Material Commitments Invoiced - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCOMXIS', label:'JCOMXIS', description: 'Subcontract Commitments Invoiced - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCOMXIE', label:'JCOMXIE', description: 'Equipment Commitments Invoiced - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCOMXIB', label:'JCOMXIB', description: 'Overhead Commitments Invoiced - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JCOMXIO', label:'JCOMXIO', description: 'Other Commitments Invoiced - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDXLC', label:'JJTDXLC', description: 'Job to date (Labor) Accumulation Period Totals - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDXLU', label:'JJTDXLU', description: 'Job to date (Labor Units) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDXMC', label:'JJTDXMC', description: 'Job to date (Material) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDXSC', label:'JJTDXSC', description: 'Job to date (Subcontract) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDXEC', label:'JJTDXEC', description: 'Job to date (Equipment) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDXEU', label:'JJTDXEU', description: 'Job to date (Equipment Units) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDXBC', label:'JJTDXBC', description: 'Job to date (Overhead) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDXOC', label:'JJTDXOC', description: 'Job to date (Other) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JMTDXLC', label:'JMTDXLC', description: 'Month to date (Labor) Accumulation Period Totals - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JMTDXLU', label:'JMTDXLU', description: 'Month to date (Labor Units) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JMTDXMC', label:'JMTDXMC', description: 'Month to date (Material) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JMTDXSC', label:'JMTDXSC', description: 'Month to date (Subcontract) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JMTDXEC', label:'JMTDXEC', description: 'Month to date (Equipment) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JMTDXEU', label:'JMTDXEU', description: 'Month to date (Equipment Units) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JMTDXBC', label:'JMTDXBC', description: 'Month to date (Overhead) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JMTDXOC', label:'JMTDXOC', description: 'Month to date (Other) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLMXLC', label:'JLMXLC', description: 'Last month (Labor) Accumulation Period Totals - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLMXLU', label:'JLMXLU', description: 'Last month (Labor Units) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLMXMC', label:'JLMXMC', description: 'Last month (Material) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLMXSC', label:'JLMXSC', description: 'Last month (Subcontract) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLMXEC', label:'JLMXEC', description: 'Last month (Equipment) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLMXEU', label:'JLMXEU', description: 'Last month (Equipment Units) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLMXBC', label:'JLMXBC', description: 'Last month (Overhead) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JLMXOC', label:'JLMXOC', description: 'Last month (Other) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JNMXLC', label:'JNMXLC', description: 'Next Month (Labor) Accumulation Period Totals - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JNMXLU', label:'JNMXLU', description: 'Next Month (Labor Units) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JNMXMC', label:'JNMXMC', description: 'Next Month (Material) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JNMXSC', label:'JNMXSC', description: 'Next Month (Subcontract) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JNMXEC', label:'JNMXEC', description: 'Next Month (Equipment) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JNMXEU', label:'JNMXEU', description: 'Next Month (Equipment Units) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JNMXBC', label:'JNMXBC', description: 'Next Month (Overhead) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JNMXOC', label:'JNMXOC', description: 'Next Month (Other) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPTDXLC', label:'JPTDXLC', description: 'Week to date (Labor) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPTDXLU', label:'JPTDXLU', description: 'Week to date (Labor Units) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPTDXEC', label:'JPTDXEC', description: 'Week to date (Equipment) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JPTDXEU', label:'JPTDXEU', description: 'Week to date (Equipment Units) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDXLD', label:'JJTDXLD', description: 'Labor (Dollars Paid) - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDXMD', label:'JJTDXMD', description: 'Material - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDXSD', label:'JJTDXSD', description: 'Subcontract - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDXED', label:'JJTDXED', description: 'Equipment - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDXBD', label:'JJTDXBD', description: 'Overhead - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JJTDXOD', label:'JJTDXOD', description: 'Other - Extras', disabled: false, required: false, direction: 'one-way-followup'},

        {value:'JXEFA1', label:'JXEFA1', description: 'Msc job amt 1 - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXEFA2', label:'JXEFA2', description: 'Msc job amt 2 - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXEFA3', label:'JXEFA3', description: 'Msc job amt 3 - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXPFA1', label:'JXPFA1', description: 'Stored Material - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXPFA2', label:'JXPFA2', description: 'Cost at Comp - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXPFA3', label:'JXPFA3', description: 'Cost to Comp - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXPFA4', label:'JXPFA4', description: 'Lab Hrs to Comp - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXPFA5', label:'JXPFA5', description: 'Msc CC amt 5 - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXPFA6', label:'JXPFA6', description: 'Msc CC amt 6 - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXCFA1', label:'JXCFA1', description: 'Msc cat amt 1 - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXCFA2', label:'JXCFA2', description: 'Msc cat amt 2 - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXCFA3', label:'JXCFA3', description: 'Msc cat amt 3 - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JXCFA4', label:'JXCFA4', description: 'Msc cat amt 4 - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JFRMTX1', label:'JFRMTX1', description: 'Custom total 1 - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JFRMTX2', label:'JFRMTX2', description: 'Custom total 2 - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JFRMTX3', label:'JFRMTX3', description: 'Custom total 3 - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JFRMTX4', label:'JFRMTX4', description: 'Custom total 4 - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JFRMTX5', label:'JFRMTX5', description: 'Custom total 5 - Extras', disabled: false, required: false, direction: 'one-way-followup'},
        {value:'JFRMTX6', label:'JFRMTX6', description: 'Custom total 6 - Extras', disabled: false, required: false, direction: 'one-way-followup'},



    ],
    'MASTER_ARM_RECORD_1': [
        {value:'name', label:'CNAME', description: 'Customer Name', disabled: false, required: true, direction: 'two-ways' },
        {value:'customer_code', label:'CUST', description: 'Customer Code', disabled: false, required: true, direction: 'two-ways' },
        {value:'street_1', label:'CADD1', description: 'Address 1', disabled: false, required: false, direction: 'two-ways' },
        {value:'street_2', label:'CADD2', description: 'Address 2', disabled: false, required: false, direction: 'two-ways' },
        {value:'city', label:'CCITY', description: 'City', disabled: false, required: false, direction: 'two-ways' },
        {value:'state', label:'CSTATE', description: 'State', disabled: false, required: false, direction: 'two-ways' },
        {value:'postal_code', label:'CZIP', description: 'ZIP', disabled: false, required: false, direction: 'two-ways' },
        {value:'phone', label:'CPHONE', description: 'Phone', disabled: false, required: false, direction: 'two-ways' },
        {value:'email', label:'CEMAIL', description: 'Email', disabled: false, required: false, direction: 'two-ways' },
        {value:'status', label:'CSTATUS', description: 'Status', disabled: false, required: false, direction: 'two-ways' },
        {value:'type', label:'CTYPEA', description: 'Type', disabled: false, required: false, direction: 'two-ways' },

        {value:'CFAX', label:'CFAX', description: 'FAX', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CADD3', label:'CADD3', description: 'Address 3', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CADD4', label:'CADD4', description: 'Address 4', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CTRADE', label:'CTRADE', description: 'Trade', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CAKEY1', label:'CAKEY1', description: 'Key 1', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CAKEY2', label:'CAKEY2', description: 'Key 2', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CESTDT', label:'CESTDT', description: 'Date Established', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CGLPREF', label:'CGLPREF', description: 'GL Prefix', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CDAYDUE', label:'CDAYDUE', description: 'Days before due', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CSNDSTM', label:'CSNDSTM', description: 'Send Statement', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLPORQ', label:'CCLPORQ', description: 'PO Required', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCRDLMT', label:'CCRDLMT', description: 'Credit Limit', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCRDRTG', label:'CCRDRTG', description: 'Credit Rating', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCONT1', label:'CCONT1', description: 'Contact 1', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCONT2', label:'CCONT2', description: 'Contact 2', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCONT3', label:'CCONT3', description: 'Contact 3', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCONT4', label:'CCONT4', description: 'Contact 4', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCONT5', label:'CCONT5', description: 'Contact 5', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCONT6', label:'CCONT6', description: 'Contact 6', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCONT7', label:'CCONT7', description: 'Contact 7', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCONT8', label:'CCONT8', description: 'Contact 8', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCONT9', label:'CCONT9', description: 'Contact 9', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCONT10', label:'CCONT10', description: 'Contact 10', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CBADD1', label:'CBADD1', description: 'Billing Address 1', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CBADD2', label:'CBADD2', description: 'Billing Address 2', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CBADD3', label:'CBADD3', description: 'Billing Address 3', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CBADD4', label:'CBADD4', description: 'Billing Address 4', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CBCIY', label:'CBCIY', description: 'Billing City', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CBSTATE', label:'CBSTATE', description: 'Billing State', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CBZIP', label:'CBZIP', description: 'Billing ZIP', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CBEMAIL', label:'CBEMAIL', description: 'Billing Email', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CBCONT', label:'CBCONT', description: 'Billing Contact', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CINVFMT', label:'CINVFMT', description: 'BL Invoice Format', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CBFREQA', label:'CBFREQA', description: 'Billing Frequency', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CRETG', label:'CRETG', description: 'Retainage', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CLSTINT', label:'CLSTINT', description: 'Auto Text', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CLSTINN', label:'CLSTINN', description: 'Last Auto Number', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CFCXMPT', label:'CFCXMPT', description: 'Exempt from finance charge', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CFCRT', label:'CFCRT', description: 'Finance Charge', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CFCPERC', label:'CFCPERC', description: 'Percentage', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CFCFLAT', label:'CFCFLAT', description: 'Flat Rate', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CRATEL', label:'CRATEL', description: 'Rate Labor', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CRATEM', label:'CRATEM', description: 'Rate Material', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CRATES', label:'CRATES', description: 'Rate Subcontract', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CRATEE', label:'CRATEE', description: 'Rate Equipment', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CRATEO', label:'CRATEO', description: 'Rate Overhead', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CRATET', label:'CRATET', description: 'Rate Other', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CMARKTB', label:'CMARKTB', description: 'Markup table', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CADDTB', label:'CADDTB', description: 'Add-on table', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CTXGRTB', label:'CTXGRTB', description: 'Tax Total Billed', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CTXGR', label:'CTXGR', description: 'Tax Group', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CTXGRPL', label:'CTXGRPL', description: 'Tax Labor', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CTXGRPM', label:'CTXGRPM', description: 'Tax Material', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CTXGRPS', label:'CTXGRPS', description: 'Tax Subcontract', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CTXGRPE', label:'CTXGRPE', description: 'Tax Equipment', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CTXGRPO', label:'CTXGRPO', description: 'Tax Overhead', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CTXGRPT', label:'CTXGRPT', description: 'Tax Other', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CRCERT', label:'CRCERT', description: 'Resale cert', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CABN', label:'CABN', description: 'ABN', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLST1', label:'CCLST1', description: 'Credit App Rec Checklist', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLSTD1', label:'CCLSTD1', description: 'Credit App Rec Date', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLST2', label:'CCLST2', description: 'Checklist 2', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLSTD2', label:'CCLSTD2', description: 'Checklist Date 2', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLST3', label:'CCLST3', description: 'Checklist 3', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLSTD3', label:'CCLSTD3', description: 'Checklist Date 3', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLST4', label:'CCLST4', description: 'Checklist 4', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLSTD4', label:'CCLSTD4', description: 'Checklist Date 4', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLST5', label:'CCLST5', description: 'Checklist 5', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLSTD5', label:'CCLSTD5', description: 'Checklist Date 5', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLST6', label:'CCLST6', description: 'Checklist 6', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLSTD6', label:'CCLSTD6', description: 'Checklist Date 6', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLST7', label:'CCLST7', description: 'Checklist 7', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLSTD7', label:'CCLSTD7', description: 'Checklist Date 7', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLST8', label:'CCLST8', description: 'Checklist 8', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLSTD8', label:'CCLSTD8', description: 'Checklist Date 8', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLST9', label:'CCLST9', description: 'Checklist 9', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLSTD9', label:'CCLSTD9', description: 'Checklist Date 9', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLST10', label:'CCLST10', description: 'Checklist 10', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLTD10', label:'CCLTD10', description: 'Checklist Date 10', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CTEXT1', label:'CTEXT1', description: 'Text 1', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CTEXT2', label:'CTEXT2', description: 'Text 2', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CTEXT3', label:'CTEXT3', description: 'Text 3', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CTEXT4', label:'CTEXT4', description: 'Text 4', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CTEXT5', label:'CTEXT5', description: 'Text 5', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CTEXT6', label:'CTEXT6', description: 'Text 6', disabled: false, required: false, direction: 'one-way-followup' },
        //----Contact Fields
        {value:'full_name', label:'CONAME', description : 'Contact Name', disabled: false, required: true, direction: 'two-ways' },
        {value:'contact_code', label:'COCONT', description : 'Contact Code', disabled: false, required: true, direction: 'two-ways' },
        {value:'email_C', label:'COEMAIL', description: 'E-mail', disabled: false, required: false, direction: 'two-ways' },
        {value:'job_title', label:'COTITLE', description: 'Job Title', disabled: false, required: false, direction: 'two-ways' },
        {value:'phone_C', label:'COPHONE', description: 'Phone', disabled: false, required: false, direction: 'two-ways' },
        {value:'mobile_phone', label:'COCPHN', description: 'Cellular', disabled: false, required: false, direction: 'two-ways' },

        {value:'COTYPEA', label:'COTYPEA', description: 'Type', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'COCUST', label:'COCUST', description: 'Customer ID', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'COTITLE', label:'COTITLE', description: 'Title', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CODEPT', label:'CODEPT', description: 'Department', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'COCOMP', label:'COCOMP', description: 'Company', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'COADD1', label:'COADD1', description: 'Address 1', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'COADD2', label:'COADD2', description: 'Address 2', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'COADD3', label:'COADD3', description: 'Address 3', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'COADD4', label:'COADD4', description: 'Address 4', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'COCITY', label:'COCITY', description: 'City', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'COSTATE', label:'COSTATE', description: 'State', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'COZIP', label:'COZIP', description: 'Zip', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'COFAX', label:'COFAX', description: 'Fax', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'COPAGER', label:'COPAGER', description: 'Pager', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'COABN', label:'COABN', description: 'ABN', disabled: false, required: false, direction: 'one-way-followup' },

    ],
    'STANDARD_ARS_RECORD_1': [
        {value:'name', label:'CNAME', description: 'Customer Name', disabled: false, required: true, direction: 'two-ways' },
        {value:'customer_code', label:'CUST', description: 'Customer Code', disabled: false, required: true, direction: 'two-ways' },
        {value:'street_1', label:'CADD1', description: 'Address 1', disabled: false, required: false, direction: 'two-ways' },
        {value:'street_2', label:'CADD2', description: 'Address 2', disabled: false, required: false, direction: 'two-ways' },
        {value:'city', label:'CCITY', description: 'City', disabled: false, required: false, direction: 'two-ways' },
        {value:'state', label:'CSTATE', description: 'State', disabled: false, required: false, direction: 'two-ways' },
        {value:'postal_code', label:'CZIP', description: 'ZIP', disabled: false, required: false, direction: 'two-ways' },
        {value:'phone', label:'CPHONE', description: 'Phone', disabled: false, required: false, direction: 'two-ways' },
        {value:'email', label:'CEMAIL', description: 'Email', disabled: false, required: false, direction: 'two-ways' },
        {value:'status', label:'CSTATUS', description: 'Status', disabled: false, required: false, direction: 'two-ways' },
        {value:'type', label:'CTYPEA', description: 'Type', disabled: false, required: false, direction: 'two-ways' },

        {value:'CFAX', label:'CFAX', description: 'FAX', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CADD3', label:'CADD3', description: 'Address 3', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CADD4', label:'CADD4', description: 'Address 4', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CTRADE', label:'CTRADE', description: 'Trade', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CAKEY1', label:'CAKEY1', description: 'Key 1', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CAKEY2', label:'CAKEY2', description: 'Key 2', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CESTDT', label:'CESTDT', description: 'Date Established', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CGLPREF', label:'CGLPREF', description: 'GL Prefix', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CDAYDUE', label:'CDAYDUE', description: 'Days before due', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CSNDSTM', label:'CSNDSTM', description: 'Send Statement', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLPORQ', label:'CCLPORQ', description: 'PO Required', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCRDLMT', label:'CCRDLMT', description: 'Credit Limit', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCRDRTG', label:'CCRDRTG', description: 'Credit Rating', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCONT1', label:'CCONT1', description: 'Contact 1', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCONT2', label:'CCONT2', description: 'Contact 2', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCONT3', label:'CCONT3', description: 'Contact 3', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCONT4', label:'CCONT4', description: 'Contact 4', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCONT5', label:'CCONT5', description: 'Contact 5', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCONT6', label:'CCONT6', description: 'Contact 6', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCONT7', label:'CCONT7', description: 'Contact 7', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCONT8', label:'CCONT8', description: 'Contact 8', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCONT9', label:'CCONT9', description: 'Contact 9', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCONT10', label:'CCONT10', description: 'Contact 10', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CBADD1', label:'CBADD1', description: 'Billing Address 1', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CBADD2', label:'CBADD2', description: 'Billing Address 2', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CBADD3', label:'CBADD3', description: 'Billing Address 3', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CBADD4', label:'CBADD4', description: 'Billing Address 4', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CBCIY', label:'CBCIY', description: 'Billing City', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CBSTATE', label:'CBSTATE', description: 'Billing State', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CBZIP', label:'CBZIP', description: 'Billing ZIP', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CBEMAIL', label:'CBEMAIL', description: 'Billing Email', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CBCONT', label:'CBCONT', description: 'Billing Contact', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CINVFMT', label:'CINVFMT', description: 'BL Invoice Format', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CBFREQA', label:'CBFREQA', description: 'Billing Frequency', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CRETG', label:'CRETG', description: 'Retainage', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CLSTINT', label:'CLSTINT', description: 'Auto Text', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CLSTINN', label:'CLSTINN', description: 'Last Auto Number', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CFCXMPT', label:'CFCXMPT', description: 'Exempt from finance charge', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CFCRT', label:'CFCRT', description: 'Finance Charge', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CFCPERC', label:'CFCPERC', description: 'Percentage', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CFCFLAT', label:'CFCFLAT', description: 'Flat Rate', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CRATEL', label:'CRATEL', description: 'Rate Labor', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CRATEM', label:'CRATEM', description: 'Rate Material', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CRATES', label:'CRATES', description: 'Rate Subcontract', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CRATEE', label:'CRATEE', description: 'Rate Equipment', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CRATEO', label:'CRATEO', description: 'Rate Overhead', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CRATET', label:'CRATET', description: 'Rate Other', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CMARKTB', label:'CMARKTB', description: 'Markup table', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CADDTB', label:'CADDTB', description: 'Add-on table', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CTXGRTB', label:'CTXGRTB', description: 'Tax Total Billed', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CTXGR', label:'CTXGR', description: 'Tax Group', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CTXGRPL', label:'CTXGRPL', description: 'Tax Labor', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CTXGRPM', label:'CTXGRPM', description: 'Tax Material', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CTXGRPS', label:'CTXGRPS', description: 'Tax Subcontract', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CTXGRPE', label:'CTXGRPE', description: 'Tax Equipment', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CTXGRPO', label:'CTXGRPO', description: 'Tax Overhead', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CTXGRPT', label:'CTXGRPT', description: 'Tax Other', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CRCERT', label:'CRCERT', description: 'Resale cert', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CABN', label:'CABN', description: 'ABN', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLST1', label:'CCLST1', description: 'Credit App Rec Checklist', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLSTD1', label:'CCLSTD1', description: 'Credit App Rec Date', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLST2', label:'CCLST2', description: 'Checklist 2', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLSTD2', label:'CCLSTD2', description: 'Checklist Date 2', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLST3', label:'CCLST3', description: 'Checklist 3', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLSTD3', label:'CCLSTD3', description: 'Checklist Date 3', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLST4', label:'CCLST4', description: 'Checklist 4', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLSTD4', label:'CCLSTD4', description: 'Checklist Date 4', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLST5', label:'CCLST5', description: 'Checklist 5', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLSTD5', label:'CCLSTD5', description: 'Checklist Date 5', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLST6', label:'CCLST6', description: 'Checklist 6', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLSTD6', label:'CCLSTD6', description: 'Checklist Date 6', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLST7', label:'CCLST7', description: 'Checklist 7', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLSTD7', label:'CCLSTD7', description: 'Checklist Date 7', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLST8', label:'CCLST8', description: 'Checklist 8', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLSTD8', label:'CCLSTD8', description: 'Checklist Date 8', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLST9', label:'CCLST9', description: 'Checklist 9', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLSTD9', label:'CCLSTD9', description: 'Checklist Date 9', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLST10', label:'CCLST10', description: 'Checklist 10', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CCLTD10', label:'CCLTD10', description: 'Checklist Date 10', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CTEXT1', label:'CTEXT1', description: 'Text 1', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CTEXT2', label:'CTEXT2', description: 'Text 2', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CTEXT3', label:'CTEXT3', description: 'Text 3', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CTEXT4', label:'CTEXT4', description: 'Text 4', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CTEXT5', label:'CTEXT5', description: 'Text 5', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CTEXT6', label:'CTEXT6', description: 'Text 6', disabled: false, required: false, direction: 'one-way-followup' },
        //----Contact Fields                should be required true if any contact field is mapped
        {value:'full_name', label:'CONAME', description : 'Contact Name', disabled: false, required: false, direction: 'two-ways' },
        {value:'contact_code', label:'COCONT', description : 'Contact Code', disabled: false, required: false, direction: 'two-ways' },
        {value:'email_C', label:'COEMAIL', description: 'E-mail', disabled: false, required: false, direction: 'two-ways' },
        {value:'job_title', label:'COTITLE', description: 'Job Title', disabled: false, required: false, direction: 'two-ways' },
        {value:'phone_C', label:'COPHONE', description: 'Phone', disabled: false, required: false, direction: 'two-ways' },
        {value:'mobile_phone', label:'COCPHN', description: 'Cellular', disabled: false, required: false, direction: 'two-ways' },

        {value:'COTYPEA', label:'COTYPEA', description: 'Type', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'COCUST', label:'COCUST', description: 'Customer ID', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'COTITLE', label:'COTITLE', description: 'Title', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'CODEPT', label:'CODEPT', description: 'Department', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'COCOMP', label:'COCOMP', description: 'Company', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'COADD1', label:'COADD1', description: 'Address 1', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'COADD2', label:'COADD2', description: 'Address 2', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'COADD3', label:'COADD3', description: 'Address 3', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'COADD4', label:'COADD4', description: 'Address 4', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'COCITY', label:'COCITY', description: 'City', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'COSTATE', label:'COSTATE', description: 'State', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'COZIP', label:'COZIP', description: 'Zip', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'COFAX', label:'COFAX', description: 'Fax', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'COPAGER', label:'COPAGER', description: 'Pager', disabled: false, required: false, direction: 'one-way-followup' },
        {value:'COABN', label:'COABN', description: 'ABN', disabled: false, required: false, direction: 'one-way-followup' },

    ],

    'CHANGE_ORDER': [
        {value:'UDESC', label:'UDESC', description : 'Description', disabled: false, required: false},
        {value:'UEXTRA', label:'UEXTRA', description : 'Extra', disabled: false, required: false},
        {value:'UDATE', label:'UDATE', description : 'Date', disabled: false, required: false},
        {value:'UTYPE', label:'UTYPE', description : 'Type', disabled: false, required: false},
        {value:'STYPE', label:'STYPE', description : 'Contract', disabled: false, required: false},
        {value:'estimate_amount', label:'estimate_amount', description : 'Estimate', disabled: false, required: false},
        {value:'USCOPE', label:'USCOPE', description : 'Scope of change', disabled: false, required: false},
        {value:'cost_amount', label:'cost_amount', description : 'Committed Cost', disabled: false, required: false},
        {value:'Gross_Margin', label:'Gross_Margin', description : 'Gross Margin %', disabled: false, required: false},
        {value:'UJOB', label:'UJOB', description : 'Unit', disabled: false, required: false},
        {value:'UAMT', label:'UAMT', description : 'Total Estimate', disabled: false, required: false},
    ],
};

export const spectrumFieldLabelsMapping = {
    "JC_JOB_MASTER_MC": {
        "Job_Number": "Job Code",
        "Master_Job": "Master",
        "Cost_Center": "Cost Center",
        "Job_Description": "Name",
        "Address_1": "Address",
        "Zip_Code": "Postal code",
        "Phone": "Telephone",
        "Fax_Phone": "Fax",
        "Status_Code": "Status",
        "Contract_Number": "Contract #",
        "Total_Units": "Job units",
        "Unit_of_Measure": "Unit of Measure",
        "Price_Method_Code": "Price Type",
        "Job_Site_Phone": "Site Phone",
        "Taxable_Flag": "Taxable",
        "Customer_Code": "Customer",
        "Est_Start_Date": "Estimated start date",
        "Est_Complete_Date": "Estimated complete",
        "Projected_Complete_Date": "Projected complete",
        "Create_Date": "Job create date",
        "Start_Date": "Actual start date",
        "Complete_Date": "Actual complete",
        "PR_OH_Type_Code": "Payroll Overhead Type",
        "PR_OH_Amount": "Payroll Overhead Rate",
        "Payroll_OH_Percent": "Payroll Overhead Percent",
        "OH_Phase": "Payroll Overhead Phase",
        "OH_Cost_Type": "Payroll Overhead Cost type",
        "Certified_Project_ID": "Certified Project ID",
        "Work_State_Tax_Code": "Work state",
        "Work_County_Tax_Code": "Work county",
        "Work_Local_Tax_Code": "Work local",
        "Work_Comp_Code": "Worker's compensation",
        "Pre_TC_Burden_Percent": "Pre-time card %",
        "Burden_Phase": "Payroll burden Phase",
        "Burden_Cost_Type": "Payroll burden Cost type",
        "Job_Oh_Batch_Code": "Job overhead batch",
        "Earned_Calc_Type": "Earned revenue calculation",
        "Under_Billed": "Unbilled amount",
        "Phase_Display_Code": "Phase mask",
        "Major_Group_Start": "Major group start position",
        "Major_Group_End": "Major group end position",
        "Minor_Group_Start": "Minor group start position",
        "Minor_Group_End": "Minor group end position",
        "Job_Type": "Contract type",
        "Routing_Limit": "Invoice dollar limit",
        "Routing_Code1": "Default routing code",
        "Routing_Code2": "Routing code if over limit",
    },
    "CR_CUSTOMER_MASTER_MC": {
        "Customer_Code" : "Code",
        "Address_1" : "Address",
        "Zip_Code" : "Postal Code",
        "Fax_Phone" : "Fax",
        "Terms_Code" : "Terms",
        "Customer_Email" : "Customer e-mail",
        "WO_Warning_Message" : "Work order warning",
        "Price_Level_Labor" : "Price codes Labor",
        "Price_Level_Material" : "Price codes Material",
        "Finance_Charge_Tran_Code" : "Finance charge code",
        "Date_Created" : "Date established",
        "Taxable_Flag" : "Invoice defaults Taxable",
        "Standard_Retention_Percent" : "Invoice defaults Retention",
        "Statement_Flag" : "Send statements",
    }
}
